"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("typeface-roboto");
var es_1 = require("@material-ui/core/es");
var mobx_react_1 = require("mobx-react");
var core_1 = require("@material-ui/core");
var CssBaseline_1 = __importDefault(require("@material-ui/core/es/CssBaseline/CssBaseline"));
var CharacterDataStore_1 = require("./stores/CharacterDataStore");
var AllCardsView_1 = __importDefault(require("./components/AllCardsView"));
var SelectedCardsView_1 = __importDefault(require("./components/SelectedCardsView"));
var LocalStorageService_1 = require("./services/LocalStorageService");
var localStoreService = new LocalStorageService_1.LocalStorageService();
var characterDataStore = new CharacterDataStore_1.CharacterDataStore(localStoreService);
var theme = core_1.createMuiTheme({
    typography: {
        useNextVariants: true
    }
});
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.render = function () {
        return (react_1.default.createElement(mobx_react_1.Provider, { characterDataStore: characterDataStore, localStoreService: localStoreService },
            react_1.default.createElement(es_1.MuiThemeProvider, { theme: theme },
                react_1.default.createElement(CssBaseline_1.default, null),
                react_1.default.createElement(AllCardsView_1.default, null),
                react_1.default.createElement(SelectedCardsView_1.default, null))));
    };
    return App;
}(react_1.Component));
exports.default = App;



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 259
// module chunks = 0